import { FaExclamationTriangle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import CardNotificacaoBase from "./CardNotificacaoBase";

const CardFarmaco = ({ notif }) => {
    const navigate = useNavigate();
    const info = notif.reporte_info;

    if (!info) return null;

    const titulo = `Novo reporte de ${info.prestador_nome}`;
    const descricao = "Um novo evento adverso foi reportado.";
    
    let dataDisplay = notif.data_criacao || "-";

    if (dataDisplay !== "-" && !dataDisplay.includes("/")) {
        try {
             dataDisplay = new Date(dataDisplay).toLocaleString("pt-BR");
        } catch (e) {}
    }

    const handleClick = () => {
        navigate(`/reportes-farmaco/detalhe/${info.id}`);
    };

    return (
        <CardNotificacaoBase
            notificacao={notif}
            icon={<FaExclamationTriangle />}
            color="warning"
            text="text-warning"
            label="Farmacovigilância"
            titulo={titulo}
            descricao={descricao}
            dataFormatada={dataDisplay}
            onClick={handleClick}
        />
    );
};

export default CardFarmaco;
